import { Maybe, PaymentMethodsCustomerBankAccountSepaType } from "@oysterhr/schema"
import { Button, Modal, Toast, useToast } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { companyPaymentMethodsPath } from "@oysterhr/router"
import { useDeletePaymentMethod } from "../actions"

interface GenerateMandateErrorModalProps {
  isOpen: boolean
  companyId: string
  paymentMethod?: Maybe<PaymentMethodsCustomerBankAccountSepaType>
  onClose: () => void
}

export const GenerateMandateErrorModal = ({
  isOpen,
  companyId,
  paymentMethod,
  onClose,
}: GenerateMandateErrorModalProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow", {
    keyPrefix: "generateMandateErrorModal",
  })
  const navigate = useNavigate()
  const toast = useToast()

  const { deletePaymentMethod, loading } = useDeletePaymentMethod({
    successCallback: () => {
      toast({
        render: (
          <Toast variation="warning">
            <Toast.Content>{t("paymentDeleted")}</Toast.Content>
          </Toast>
        ),
      })
      navigate(companyPaymentMethodsPath(companyId))
    },
    failureCallback: errors => {
      toast({
        render: (
          <Toast variation="error">
            <Toast.Content>{errors.join(", ")}</Toast.Content>
          </Toast>
        ),
      })
    },
  })

  const onCancel = () => {
    navigate(companyPaymentMethodsPath(companyId))
  }

  if (!paymentMethod) return null

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Header align="center" icon="WarningCircle" iconVariation="error">
        {t("title")}
      </Modal.Header>
      <Modal.Content>{t("content")}</Modal.Content>
      <Modal.Footer>
        <Button variation="outline" onClick={onCancel}>
          {t("btnCancel")}
        </Button>
        <Button
          variation="danger"
          isLoading={loading}
          onClick={() => deletePaymentMethod(paymentMethod)}
        >
          {t("btnRemove")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
